import { render, staticRenderFns } from "./NavigationLeftMenu.vue?vue&type=template&id=5803f5e3&scoped=true"
import script from "./NavigationLeftMenu.vue?vue&type=script&lang=js"
export * from "./NavigationLeftMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigationLeftMenu.vue?vue&type=style&index=0&id=5803f5e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5803f5e3",
  null
  
)

export default component.exports